import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { RequestOption } from '../../model/common.model';
import { NgxMatPage } from './ngx-mat-paginator.model';

const MAX_BUTTON_NAVIGATE = 7;

@Component({
  selector: 'app-ngx-mat-paginator',
  templateUrl: './ngx-mat-paginator.component.html',
  styleUrls: ['./ngx-mat-paginator.component.scss']
})
export class NgxMatPaginatorComponent implements OnInit, OnChanges {

  totalPage = 0;
  pages: NgxMatPage[] = [];
  itemsPerpages = 0;
  totalElements = 0;
  pageIndex = -1;
  pageSizeSelected = -1;

  showFrom = 0;
  showTo = 0;

  @Input() pageSizeOptions: number[] = [25, 50, 100, 250];
  @Input() requestOption: RequestOption = new RequestOption();
  @Output() requestOptionChange: EventEmitter<RequestOption> = new EventEmitter<RequestOption>();

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.requestOption) {
     this.initialData(this.requestOption);
    }
  }

  ngOnInit() {
    this.pageSizeSelected = this.pageSizeOptions[0];
    this.initialData(this.requestOption);
  }


  initialData(requestOption: RequestOption) {
    this.itemsPerpages = requestOption.pagingOptions.size || 0;
    this.totalElements = requestOption.pagingOptions.totalElements || 0;
    this.pageIndex = requestOption.pagingOptions.number || 0;
    this.totalPage = requestOption.pagingOptions.totalPages || 0;
    this.pages = this.generatePage(this.totalPage, MAX_BUTTON_NAVIGATE, this.pageIndex) || [];

    this.showFrom = this.pageSizeSelected * this.pageIndex + 1;
    this.showTo = this.showFrom + this.pageSizeSelected - 1;
    if (this.showTo >= this.totalElements) {
      this.showTo = this.totalElements;
    }
  }

  onChangePageSizeSelected(event: MatSelectChange) {
    this.changePageSizeSelected(event.value);
  }

  onPage(index: number): void {
    this.pageIndex = index;
    this.changePageIndex(this.pageIndex);
  }

  onPreviousPage(): void {
    this.changePageIndex(this.pageIndex - 1);
  }

  onNextPage(): void {
    this.changePageIndex(this.pageIndex + 1);
  }

  private changePageSizeSelected(index: number): void {
    this.requestOption.pagingOptions.number = 0;
    this.requestOption.pagingOptions.size = index;
    this.requestOptionChange.emit(this.requestOption);
  }

  private changePageIndex(index: number): void {
    this.requestOption.pagingOptions.number = index;
    this.requestOptionChange.emit(this.requestOption);
  }

  private generatePage(length: number, maxLength: number, currentIndex: number): NgxMatPage[] {
    let result: NgxMatPage[] = [];
    result = this.getKeys(length, maxLength, currentIndex)
    .map((index) => {
      return new NgxMatPage(index, index !== -1 ? index + 1 : '...', index === -1);
    });

    return result;
  }

  private getKeys(length: number, max: number, index: number): number[] {
    const result: number[] = [];
    let i = 0;
    let isleft = true;

    // re-format invalid parameter
    if (length === 0) { return result; }
    if (max > length) { max = length; }

    const compare = Math.abs(index) -  Math.abs(length - index);
    if (compare > 0) { isleft = false; }

    const halfMax = Math.round(max / 2);

    if (length < max) { isleft = true; }
    if (isleft) {
      // go to 1
      let goLeft = index;
      while (goLeft >= 0 && i <= halfMax) {
        result.splice(0, 0, goLeft);
        goLeft--;
        i++;
      }

      if (i < max) {
        // go next
        let goNext = index + 1;
        while (i < max) {
          result.push(goNext);
          goNext++;
          i++;
        }
      }

    } else {
      // go to last - 1
      let goRight = index;

      while (goRight < length && i <= halfMax) {
        result.push(goRight);
        goRight++;
        i++;
      }

      if (i < max) {
        // go back
        let goBack = index - 1;

        while (i < max) {
          result.splice(0, 0, goBack);
          goBack--;
          i++;
        }
      }
    }


    // append ellipsis effect
    if (result.length >= max && max >= 5 && (result[0] !== 0 || result[max - 1] !== length - 1)) {
      // case 1: if first index <> 0 => return 0, -1, x, y
      if (result[0] !== 0) {
        result.splice(0, 2, 0, -1);
      }
      // case 2: if last index <> length - 1 => return x, y, -1, length - 1
      if (result[max - 1] !== length - 1) {
        result.splice(max - 2, 2, -1, length - 1);
      }
    }

    return result;
  }

}
